// extracted by mini-css-extract-plugin
module.exports = {"pageInfo":"paragraph_pageInfo__5E_4L","title":"paragraph_title__RwJ3O","description":"paragraph_description__ytx2a","paragraph":"paragraph_paragraph__fy2WZ"};